<template>
  <v-card
    id="encours"
    fluid
  >
  <v-card-title class="blue darken-3">
          <span class="text-h5 white--text">{{title}}</span>

  </v-card-title>
  
<v-banner></v-banner>





<template>
  <v-data-table
    :headers="headers"
    :items="datas"
    :items-per-page="10"
    class="elevation-1"
  >
  <template v-slot:top>
    <v-toolbar flat>
      <v-toolbar-title></v-toolbar-title>

        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>

        <v-spacer></v-spacer>
                  
        <v-dialog v-model="dialogue_ADD" width="1000">
          <v-card>
            <v-card-title class="headline">


              <v-row >

                <v-col>
                  <v-text-field
                    v-model="values.id"
                    label="id"
                    class="required"
                  ></v-text-field>
                </v-col>

                
                <v-col cols="6">
                  <v-text-field
                    v-model="values.nom"
                    label="Nom"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.projet"
                    label="Projet"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.type"
                    label="Type"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.l_annees"
                    label="Années"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.plateforme"
                    label="Plateforme"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.id_disque"
                    label="ID Disque"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.ip"
                    label="IP"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.url"
                    label="Url"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.montage"
                    label="Montage"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.taille"
                    label="Taille"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.utilisation"
                    label="Utilisation"
                    class="required"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="values.l_utilisations"
                    label="Utilisations"
                    class="required"
                  ></v-text-field>
                </v-col>



                <v-col cols="6">
                  <v-text-field
                    v-model="values.comment"
                    label="Notes"
                    class="required"
                  ></v-text-field>
                </v-col>



              </v-row>


              <v-spacer></v-spacer>

              <v-btn 
                  :loading="v_loading" 
                  color="success" 
                  text
                  :disabled="  !(
                      true
                    )"
                  @click="Save_sp">Save</v-btn>


              <v-btn color="error" text @click="dialogue_ADD = false">Cancel</v-btn>              

            </v-card-title>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogue_EDIT" width="1000">
          <v-card>
            <v-card-title class="headline">




              <v-row >

<v-col>
  <v-text-field
    v-model="values.id"
    label="id"
    class="required"
  ></v-text-field>
</v-col>


<v-col cols="6">
  <v-text-field
    v-model="values.nom"
    label="Nom"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.projet"
    label="Projet"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.type"
    label="Type"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.l_annees"
    label="Années"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.plateforme"
    label="Plateforme"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.id_disque"
    label="ID Disque"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.ip"
    label="IP"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.url"
    label="Url"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.montage"
    label="Montage"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.taille"
    label="Taille"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.utilisation"
    label="Utilisation"
    class="required"
  ></v-text-field>
</v-col>

<v-col cols="6">
  <v-text-field
    v-model="values.l_utilisations"
    label="Utilisations"
    class="required"
  ></v-text-field>
</v-col>



<v-col cols="6">
  <v-text-field
    v-model="values.comment"
    label="Notes"
    class="required"
  ></v-text-field>
</v-col>



</v-row>


              <v-spacer></v-spacer>

              <v-btn 
                  :loading="v_loading" 
                  color="success" 
                  text
                  :disabled="  !(
                      true
                    )"
                  @click="Update_sp">Save</v-btn>


              <v-btn color="error" text @click="dialogue_EDIT = false">Cancel</v-btn>              

            </v-card-title>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog"
          max-width="500px"
          :retain-focus="false"
        >

        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:[`item.actions`]="{ item }">


      <v-icon 
        v-if="true"
        small
        color="success"
        class="ma-2"
        @click="Edit_sp(item)"
        >mdi-pencil
      </v-icon>

      <v-icon
      v-if="true"
        small
        color="error"
        class="ma-2"
        @click="Delete_sp(item)"
        >mdi-delete
      </v-icon>


      <v-dialog v-model="dialogue_DELETE"
        max-width="1000px"
        style="z-index: 1000"
        :retain-focus="false"
      >
        <v-card flat>
          
          <v-card-title>
            
            <span class="headline" >Do you really want to remove it ?
            </span>

          </v-card-title>
          <v-card-actions>

            <v-spacer></v-spacer>

            <v-btn 
              color="success"
              class="ma-2"
              dark
              @click="objet_close()"
              >Cancel
            </v-btn>

            <v-btn
              color="error"
              class="ma-2"
              dark
              @click="Delete_This()"
              >Yes
            </v-btn>
                          
          </v-card-actions>
          
        </v-card>
      </v-dialog>

    </template>

    <template>


    </template>



  </v-data-table>






</template>

</v-card>
</template>
<script>
  

  


  export default {

    data: () =>({

      texte_test :"tête vide",
      dialog : false,

      dialogue_ADD : false,
      dialogue_EDIT : false,
      dialogue_DELETE : false,
 
      item_t : 0,

      headers: [
          { text: 'ID',value : 'id'},
          { text: 'Nom Volume', value: 'nom',align: 'start', sortable: true },
          { text: 'Plateforme', value: 'plateforme' },
          { text: 'Projet', value: 'projet' },
          { text: 'Type', value: 'type' },
          { text: 'Années', value:'l_annees'},
          { text: 'Montage',value : 'montage'},
          { text: 'Capacitée',value : 'taille'},
          { text: 'Utilisation',value : 'utilisation'},
          { text: 'Utilisations',value : 'l_utilisations'},
          { text: 'Notes',value : 'comment'}


        ],
      title : "Volumes",
      N_Dernieres : 1,

      base_node : "/sss/DATA_volumes",

      values :{},


      values_0 :{
        id : -1,
        nom : "",
        projet : "",
        type : "",
        annees : {},
        l_annees : "{}",
        plateforme : "",
        id_disque : -1,
        ip : "10.10.10.255",
        url : "10.10.10.255:/mnt/data",
        montage : "/dev/nul",
        taille : 1024000000000,
        utilisation : 0,
        utilisations : {},
        l_utilisations : "{}",
        comment : ""
      },


      datas:[],
      hosts:[],
      datas_t:[],

      v_loading : false

    }),
  initialize(){

  },
  created(){
    this.values = JSON.parse(JSON.stringify(this.values_0));
  },
  beforeMount(){
     

  },
  mounted(){

   

    this.load_sp();
    this.set_sp();
    this.A_Update = setInterval(() => {
      this.load_sp();
      this.set_sp();
    },2000);
  },
  destroyed: function () {
    clearInterval(this.A_Update);
  },

  methods: {

    load_sp(){

      const othis = this;

      this.axios.get( backend_url  + this.base_node + "",{})
      .then((res) => {

        
          othis.datas_t = JSON.parse(JSON.stringify(res.data.data));
          this.hosts = JSON.parse(JSON.stringify(res.data.hosts));
          this.datas = JSON.parse(JSON.stringify(othis.datas_t));
          
      })
      .catch(() => {
        console.log("PB au chargement");
      });

    },
    set_sp(){

      this.datas = JSON.parse(JSON.stringify(this.datas_t));
      //console.log(this.target);

    },  

    add_sp(){
      console.log("ok on y est");
      this.values = JSON.parse(JSON.stringify(this.values_0));
      this.dialogue_ADD = true;
    },
    close_sp(){
      dialogue_ADD = false;
      dialogue_EDIT = false;
      dialogue_DELETE = false;
    },

    Delete_sp(item){

      this.item_t = item;
      this.dialogue_DELETE = true;

    },
    Edit_sp(item){

      this.values = JSON.parse(JSON.stringify(item));
      this.dialogue_EDIT= true;

    },
    Delete_This(){

      const othis = this;

      this.axios.delete( backend_url  + this.base_node + "/"+othis.item_t.id,{})
      .then((res) => {

          othis.datas_t = JSON.parse(JSON.stringify(res.data.data));
          this.hosts = JSON.parse(JSON.stringify(res.data.hosts));
          this.datas = JSON.parse(JSON.stringify(othis.datas_t));

          this.dialogue_DELETE = false;
      })
      .catch(() => {
        console.log("PB  de suppréssion");
        this.dialogue_DELETE = false;
      });
      
    },

    Save_sp(){

      const othis = this;

      this.values.annees = JSON.parse(this.values.l_annees);
      this.values.utilisations = JSON.parse(this.values.l_utilisations);

      console.log(this.values);
      this.axios.post( backend_url  + this.base_node + "",this.values)
      .then((res) => {

          othis.datas_t = JSON.parse(JSON.stringify(res.data.data));
          this.hosts = JSON.parse(JSON.stringify(res.data.hosts));
          this.datas = JSON.parse(JSON.stringify(othis.datas_t));

          this.dialogue_ADD = false;
      })
      .catch(() => {
        console.log("PB de soumission");
        this.dialogue_ADD = false;
      });

    },
    Update_sp(){

      const othis = this;

      this.values.annees = JSON.parse(this.values.l_annees);
      this.values.utilisations = JSON.parse(this.values.l_utilisations);

      this.axios.put( backend_url + this.base_node + "/"+this.values.id,this.values)
      .then((res) => {

          othis.datas_t = JSON.parse(JSON.stringify(res.data));
          this.hosts = JSON.parse(JSON.stringify(res.data.hosts));
          this.datas = JSON.parse(JSON.stringify(othis.datas_t));

          this.dialogue_EDIT = false;
      })
      .catch(() => {
        console.log("PB de soumission");
        this.dialogue_EDIT = false;
      });

    }

  }
}
</script>